document.addEventListener('DOMContentLoaded', (ev) => {
    // If page missing a usable H1, add one based on most prominent text
    let real_h1 = document.querySelector('main h1');
    if (real_h1 == null || real_h1.textContent == "") {
        let pseudo_h1_text = document.querySelector('.h1') ? document.querySelector('.h1').textContent : "";
        let pseudo_h2_text = document.querySelector('.h2') ? document.querySelector('.h2').textContent : "";
        let title_text = document.querySelector('title') ? document.querySelector('title').textContent : "";
        let h1_text = pseudo_h1_text;
        h1_text = h1_text || title_text;
        h1_text = h1_text || pseudo_h2_text;
        if (real_h1) {
            real_h1.textContent = h1_text;
        } else {
            let new_h1 = document.createElement('h1');
            new_h1.textContent = h1_text;
            new_h1.classList.add("sr-only");
            let parent = document.querySelector('main');
            parent.insertBefore(new_h1, parent.firstChild);
        }
    }
    // Convert pseudo-headings using class .h* to real heading elements for screen readers only.
    // Only in main content section of page, omit the footer.
    let h_types = ['h2','h3','h4','h5'];
    h_types.forEach(h_type => {
        document.querySelectorAll(`main p.${h_type}:not(footer .${h_type})`).forEach(ele => {
            addHeading(ele, h_type);
        })
    })
    function addHeading(ele, h_type) {
        let new_h = document.createElement(h_type);
        new_h.textContent = ele.textContent;
        new_h.classList.add("sr-only");
        ele.parentNode.insertBefore(new_h, ele);
    }

    //redirections
    (function() {
        // Map of variant/product handles to target products
        var redirects = {
        "/products/permasafe-clean-1?variant=50521879773499": "https://permasafe.com/products/permasafe-clean?variant=47916198691131",
        "/products/permasafe-shield-1?variant=50521883803963": "https://permasafe.com/products/permasafe-shield?variant=47947933286715",
        "/products/permasafe-clean-travel-size?variant=50521885475131": "https://permasafe.com/products/permasafe-clean?variant=50132221854011",
        "/products/permasafe-shield-travel-size?variant=50521886818619": "https://permasafe.com/products/permasafe-shield?variant=50132217889083"
        };

        var currentPath = window.location.pathname + window.location.search;

        if (redirects[currentPath]) {
        window.location.replace(redirects[currentPath]);
        }
    })();
})